var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_50_3407)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 21,
    r: 20,
    fill: "#1F2C46"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 21,
    r: 19.5,
    stroke: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1957 14.0317C25.2549 13.3478 24.0616 13 22.6517 13C21.5698 13 20.6408 13.247 19.8907 13.7328C18.789 14.4378 18.1546 15.7746 18.0011 17.3925C17.997 17.4478 18.0044 17.5034 18.0229 17.5557C18.0413 17.608 18.0704 17.6559 18.1084 17.6964C18.1463 17.7369 18.1922 17.7691 18.2432 17.7909C18.2942 17.8128 18.3492 17.8238 18.4046 17.8233H20.7349C20.9379 17.8233 21.1081 17.6747 21.1329 17.4736C21.1805 17.0812 21.3062 16.6362 21.5067 16.315C21.7481 15.9281 22.159 15.7406 22.7637 15.7406C23.3789 15.7406 23.7986 15.8941 24.0127 16.1961C24.2491 16.5316 24.3643 16.8924 24.3643 17.3009C24.3643 17.6475 24.2628 17.9557 24.0511 18.2503C23.936 18.4193 23.78 18.5784 23.5832 18.7269L22.9271 19.2449C22.2345 19.7896 21.8131 20.2662 21.6379 20.7056C21.4943 21.064 21.3006 21.4489 21.2226 22.2077C21.2169 22.2641 21.2231 22.321 21.2407 22.3749C21.2583 22.4287 21.2869 22.4783 21.3248 22.5204C21.3627 22.5626 21.4089 22.5963 21.4606 22.6195C21.5123 22.6427 21.5683 22.6549 21.6249 22.6552H23.9211C24.0216 22.6543 24.1182 22.6164 24.1925 22.5487C24.2667 22.4809 24.3134 22.3882 24.3234 22.2882C24.3407 22.1366 24.3698 22.0641 24.4101 21.9342C24.5091 21.621 24.7059 21.3505 25.0141 21.1091L25.6535 20.6097C26.3281 20.0799 26.7762 19.651 27.0194 19.3019C27.4409 18.7195 27.6551 17.9972 27.6551 17.1555C27.6551 15.7876 27.1637 14.7361 26.1957 14.0317ZM23.8994 28.0194H21.7549C21.6127 28.0193 21.4763 27.9627 21.3758 27.862C21.2753 27.7614 21.2189 27.625 21.2189 27.4828V25.337C21.2189 25.0399 21.459 24.8004 21.7549 24.8004H23.9007C24.1978 24.8004 24.4373 25.0405 24.4373 25.337V27.4828C24.4373 27.5533 24.4234 27.623 24.3964 27.6881C24.3695 27.7531 24.3299 27.8123 24.2801 27.862C24.2303 27.9118 24.1711 27.9513 24.106 27.9782C24.0409 28.0051 23.9711 28.0189 23.9007 28.0188L23.8994 28.0194Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_50_3407",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_50_3407"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_50_3407",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/HelpIcon.c1959d22bb31b981f38d04f0795bbbdc.svg";
export { ForwardRef as ReactComponent };